<template>
    <div>
        <div style="margin-bottom: 15px">
            <span>当前积分：{{point}}</span>
            <span style="margin-left: 5%">（当前页面显示所有类型的积分变动记录）</span>
        </div>
        <a-divider>积分变动记录</a-divider>
        <a-table
                :columns="columns"
                :data-source="rows"
                :pagination="pagination"
                @change="handleTableChange"
                style="width: 80%; margin-left: 10%"
                bordered>
            <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
            <span slot="amount" slot-scope="text, record, index">
                <b v-if="text.indexOf('+') !== -1" style="color: green">{{text}}</b>
                <b v-else style="color: red">{{text}}</b>
            </span>

        </a-table>
    </div>
</template>

<script>

    import vendorAdminService from "../../../service/vendorAdmin";
    import moment from "moment"

    export default {
        data() {
            return {
                columns: [
                    {title: '#', width: "10%", scopedSlots: { customRender: 'serial' }},
                    {title: '类型',width: "15%", dataIndex: 'type'},
                    {title: '目标',width: "15%", dataIndex: 'relatedName'},
                    {title: '变动数量',width: "10%", dataIndex: 'amount', align: 'center', scopedSlots: {customRender: 'amount'}},
                    {title: '余额',width: "15%", dataIndex: 'balance', customRender: (text) => text + "积分"},
                    {title: '创建时间',width: "20%", dataIndex: 'createTime', customRender: (text) => moment(new Date(text)).format("YYYY-MM-DD HH:mm:ss")},
                ],
                rows: [],
                pagination: {},

                point: 0
            }
        },
        mounted() {
            let params = {
                pageNo: 1,
                pageSize: 5,
            }
            this.fetch(params)
        },
        methods: {
            handleTableChange(pagination) {
                this.fetch({
                    pageNo: pagination.current,
                    pageSize: pagination.pageSize,
                    keyword: this.keyword
                })
            },
            fetch(params) {
                vendorAdminService.recordList(params).then((res) => {
                    const pagination = { ...this.pagination };
                    this.rows = res.data.record.records

                    for(let row of this.rows) {
                        switch (row.type) {
                            case 1:
                                row.type = "积分充值"
                                row.amount = `+${row.amount}`
                                break;
                            case 2:
                                row.type = "顾客兑换消费券"
                                row.amount = `+${row.amount}`
                                break;
                            case 3:
                                row.type = "赠送积分给顾客"
                                row.amount = `-${row.amount}`
                                break;
                            case 5:
                                row.type = "积分提现"
                                row.amount = `-${row.amount}`
                                break;
                        }
                    }

                    pagination.current = res.data.record.current
                    pagination.total = res.data.record.total
                    pagination.pageSize = res.data.record.size
                    pagination.showTotal = (total, range) => {
                        return `${range[0]}-${range[1]} of ${total} items`
                    }

                    this.point = res.data.point
                    this.pagination = pagination
                });
            },
        }
    }
</script>

<style scoped>

</style>
